import { AddParticipantModalComponent } from "./addParticipantModal/add-participant-modal.component";
import { ConferenceComponent } from "./conference.component";
import { AudioVideoConferenceModule } from "./audioVideoConference/audio-video-conference.module";
import { JobMatchProfileOnConferenceModule } from "./jobMatchProfileOnConference/job-match-profile-on-conference.module";
export const ConferenceModule = angular
    .module('conference', [AudioVideoConferenceModule, JobMatchProfileOnConferenceModule])
    .component(ConferenceComponent.selector, ConferenceComponent.component)
    .component(AddParticipantModalComponent.selector, AddParticipantModalComponent.component)
    .name;
//# sourceMappingURL=conference.module.js.map